<template>
	<div class="index" v-if="show">
		<div class="layui-layout layui-layout-admin" style="display: flex;flex-wrap: wrap;height: 100%;">
			<div class="layui-header zt_color layui-row" style="width:100%;box-shadow: 0 1px 3px 0px rgba(0,0,0,0.3);position: fixed;top: 0;left: 0;">
				<div class="layui-logo f_row al_itm pointer" style="color:#fff;width:auto;">
					<img src="../assets/logo.png" style="margin: 0 10px 0 20px;" height="40" width="40" alt="">
					<span class="px20">桃琼之瑶SMT活动钢网企业端</span>
				</div>
				<ul class="layui-nav layui-layout-right">
					<li @click="help" class="layui-nav-item" lay-unselect>
						<a href="javascript:;" class="px16 f_row al_itm"> <i class="layui-icon layui-icon-help px24"></i>&nbsp;疑问解答</a>
					</li>
					<li @click="newsList" class="layui-nav-item" lay-unselect>
						<a href="javascript:;" class="px16 f_row al_itm"> <i class="layui-icon layui-icon-notice px24"></i>&nbsp;{{newslen == 0 ? '消息' : newslen + '条新消息'}}</a>
					</li>
					<li @click="clearSckey" class="layui-nav-item" lay-unselect>
						<a href="javascript:;" class="px16 f_row al_itm"> <i class="iconfont icon-guanji layui-icon-close-fill px24"></i>&nbsp;退出登录</a>
					</li>
				</ul>
			</div>
			<div class="layui-side layui-bg-gray" style="padding-top: 60px;">
				<div class="layui-side-scroll">
					<ul class="layui-nav layui-nav-tree layui-nav-side px18" lay-filter="test" style="padding-top: 60px;box-sizing: border-box;">
						<li v-for="(item,index) in tabList" :key="index" class="layui-nav-item" :class="item.path == path ? 'layui-this' : ''">
							<router-link  :to="{ path: item.path }">
								<img :src="item.path == path ? item.img1 : item.img2" alt="" width="30" height="30">
								<span class="px16" style="width:80px;text-align:left;padding-left:20px;">{{item.names}}</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="layui-body" style="flex: 1;padding-top: 60px;background: #fff;">
				<div id="marquee">
					<div><i class="layui-icon layui-icon-speaker"></i></div>
					<marquee onmouseover="this.stop()" onmouseout="this.start()" scrollamount="4">
						<p v-for="item in notice" v-html="item.content"></p>
					</marquee>
				</div>
				<div class="white">
					<keep-alive>
						<router-view v-if="$route.meta.keepAlive"></router-view>
					</keep-alive>
					<router-view v-if="!$route.meta.keepAlive"></router-view>
				</div>
			</div>
		</div>
		<div id="qrCode" v-if="qrcode">
			<i class="el-icon-error close" @click.stop="onCloseQrCode"></i>
			<div id="QQ">
				<a target='_blank' href='http://wpa.qq.com/msgrd?v=3&amp;site=qq&amp;menu=yes&amp;uin=2951682271' title='在线即时交谈'><i class="layui-icon layui-icon-login-qq"></i>在线客服</a>
			</div>
			<img src="../assets/qrcode.png" title="打开微信扫一扫，关注公众号绑定手机号接收消息推送" />
			<p style="font-size: 12px;">扫码关注微信公众号<br />绑定账号接收消息提醒</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				show: false,
				fullscreen: false,
				qrcode: true,
				notice: '', //公告列表
				tabList: [{
						id: 1,
						names: '会员中心',
						img1: require('@/assets/a/1a.png'),
						img2: require('@/assets/a/1b.png'),
						icon: 'layui-icon-friends',
						path: '/memberCenter'
					},
					{
						id: 2,
						names: '收货地址',
						img1: require('@/assets/a/6a.png'),
						img2: require('@/assets/a/6b.png'),
						icon: 'layui-icon-location',
						path: '/receAddress'
					},
					{
						id: 3,
						names: '订单联系人',
						img1: require('@/assets/a/6a.png'),
						img2: require('@/assets/a/6b.png'),
						icon: 'layui-icon-location',
						path: '/phAddress'
					},
					{
						id: 4,
						names: '立即下单',
						img1: require('@/assets/a/4a.png'),
						img2: require('@/assets/a/4b.png'),
						icon: 'layui-icon-cart-simple',
						path: '/creatOrder'
					},
					{
						id: 5,
						names: '购 物 车',
						img1: require('@/assets/a/3a.png'),
						img2: require('@/assets/a/3b.png'),
						icon: 'layui-icon-form',
						path: '/shopCar'
					},
					{
						id: 6,
						names: '我的订单',
						img1: require('@/assets/a/4a.png'),
						img2: require('@/assets/a/4b.png'),
						icon: 'layui-icon-form',
						path: '/myOrder'
					},
					{
						id: 12,
						names: '月结订单',
						img1: require('@/assets/a/4a.png'),
						img2: require('@/assets/a/4b.png'),
						icon: 'layui-icon-form',
						path: '/monthly'
					},
					{
						id: 7,
						names: '售后订单',
						img1: require('@/assets/a/4a.png'),
						img2: require('@/assets/a/4b.png'),
						icon: 'layui-icon-form',
						path: '/afterSale'
					},
					{
						id: 8,
						names: '桃币明细',
						img1: require('@/assets/a/5a.png'),
						img2: require('@/assets/a/5b.png'),
						icon: 'layui-icon-file',
						path: '/memberLog'
					},
					{
						id: 9,
						names: '修改密码',
						img1: require('@/assets/a/7a.png'),
						img2: require('@/assets/a/7b.png'),
						icon: 'layui-icon-auz',
						path: '/setpsword'
					},
					{
						id: 10,
						names: '发票管理',
						img1: require('@/assets/a/8a.png'),
						img2: require('@/assets/a/8b.png'),
						icon: 'layui-icon-set-fill',
						path: '/invoiceCt'
					},
					{
						id: 11,
						names: '账号管理',
						img1: require('@/assets/a/1a.png'),
						img2: require('@/assets/a/1b.png'),
						icon: 'layui-icon-set-fill',
						path: '/account'
					}
				],
				tab_index: 1,
				path: '/memberCenter',
				t: '',
				notify: '',
				newslen: 0
			}
		},
		created() {
			let _this = this;
			api.getMemberInfo({ //获取会员信息
				token: this.getCookie('token')
			}).then((res) => {
				if(res.data.pay_type != 3) {
					for(let i = 0; i < _this.tabList.length; i++) {
						if(_this.tabList[i].id == 12) {
							_this.tabList.splice(i, 1);
						}
					}
				}
				if(res.data.pay_type != 1) {
					for(let i = 0; i < _this.tabList.length; i++) {
						if(_this.tabList[i].id == 11) {
							_this.tabList.splice(i, 1);
						}
					}
				}
				
				if(res.data.need_invoice == 0) {
					for(let i = 0; i < _this.tabList.length; i++) {
						if(_this.tabList[i].id == 10) {
							_this.tabList.splice(i, 1);
						}
					}
					_this.$store.dispatch('setStateFun', 0);
				}
				if(res.data.is_sub == 1) {
					_this.$store.dispatch('setStateFun2', 1);
					for(let i = 0; i < _this.tabList.length; i++) {
						if(_this.tabList[i].id == 9) {
							_this.tabList.splice(i, 1);
						}
						if(_this.tabList[i].id == 10) {
							_this.tabList.splice(i, 1);
						}
						if(_this.tabList[i].id == 11) {
							_this.tabList.splice(i, 1);
						}
					}
				}else {
					_this.$store.dispatch('setStateFun2', 0);
				}
				_this.show = true;
			});
		},
		mounted() {
			let _this = this;
			this.onNotice();
			layui.use(['element'], () => {
				var element = layui.element;
				element.render();
			});
			if(!sessionStorage.tests) {
				this.$router.replace('login');
			} else {
				this.getNewMsg();
				this.path = this.$route.path;
			}
		},
		destroyed() {
			this.onCloseNotify();
			clearInterval(this.t);
		},
		watch: { //监听路由变化
			$route(to, from) {
				if(this.$store.state.invoice == 0 && to.path == '/invoiceCt') {
					this.$router.replace({
						path: '/memberCenter'
					})
					return false;
				}
				if(this.$store.state.is_sub == 1 && to.path == '/setpsword') {
					this.$router.replace({
						path: '/memberCenter'
					})
					return false;
				}
				if(this.$store.state.is_sub == 1 && to.path == '/account') {
					this.$router.replace({
						path: '/memberCenter'
					})
					return false;
				}
				if(to.path == '/communicate' || to.path == '/news') {
					this.onClearFun();
					setTimeout(() => {
						this.getNewMsg2();
					}, 2000)
				} else {
					this.onStartFun();
				}
				this.path = this.$route.path;
				layui.use(['element'], () => {
					var element = layui.element;
					element.render();
				});
			}
		},
		methods: {
			help() {
				window.open("https://mr.summary88.com/mrgw_qyd/#/help");
			},
			onNotice() {
				let _this = this;
				api.notice({
					token: this.getCookie('token'),
				}).then((res) => {
					if(res.code == 1) {
						_this.notice = res.data;
					}
				})
			},
			onCloseQrCode() {
				this.qrcode = false;
			},
			onStartFun() {
				this.getNewMsg();
			},
			onClearFun() {
				clearTimeout(this.t);
			},
			clearSckey() {
				let _this = this;
				layer.open({
					type: 0,
					content: '是否确认退出登录？',
					btn: ['确定', '取消'],
					btnAlign: 'c',
					resize: false,
					closeBtn: 0,
					skin: 'demo-class',
					yes: function(index, layero) {
						layer.closeAll();
						sessionStorage.clear('tests');
						_this.delCookie('token');
						_this.$router.replace({
							path: '/login'
						})
					},
					btn2: function(index, layero) {
						layer.closeAll();
					}
				});
			},
			newsList() {
				if(this.$route.path == '/news') {
					return false;
				}
				this.$router.push({
					path: '/news'
				})
			},
			getNewMsg() {
				let _this = this;
				if(this.notify) {
					clearTimeout(this.t);
					return false;
				}
				clearTimeout(this.t);
				api.getAllMsgStatus({
					token: this.getCookie('token'),
					type: 1,
					from_user: 1, //1工程师发送，2企业发送
				}).then((res) => {
					if(res.code == 1) {
						_this.newslen = res.data.length;
						_this.notify = _this.$notify({
							title: '新消息提醒',
							message: `有工程师发来了新消息,点击查看`,
							iconClass: 'el-icon-message-solid',
							duration: 0,
							showClose: false,
							offset: 50,
							onClick: function() {
								_this.onClose()
							}
						});
					} else {
						_this.newslen = 0;
						_this.onCloseNotify();
					}
					_this.t = setTimeout(() => {
						_this.getNewMsg();
					}, 10000)
				})
			},
			getNewMsg2() {
				let _this = this;
				api.getAllMsgStatus({
					token: this.getCookie('token'),
					type: 1,
					from_user: 1, //1工程师发送，2企业发送
				}).then((res) => {
					if(res.code == 1) {
						_this.newslen = res.data.length;
					} else {
						_this.newslen = 0;
					}
				})
			},
			onClose() {
				this.$notify.closeAll();
				this.notify = '';
				this.$router.push({
					path: '/news'
				})
			},
			onCloseNotify() {
				this.$notify.closeAll();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.index{
		height: 100%;
	}
	
	#marquee {
		position: fixed;
		width: calc(100% - 220px);
		height: 40px;
		background: #fffbe8;
		top: 60px;
		left: 220px;
		z-index: 997;
		font-size: 14px;
		display: flex;
		align-items: center;
		color: #ed6a0c;
	}
	
	#marquee div {
		width: 60px;
		text-align: right;
	}
	
	#marquee div i {
		font-size: 24px;
	}
	
	#marquee marquee {
		width: 100%;
		height: 40px;
	}
	
	#marquee p {
		display: inline-block;
		height: 40px;
		line-height: 40px;
		margin-right: 50px;
	}
	
	#marquee a {
		color: #ed6a0c !important;
	}
	
	.currents {
		background: #494E62;
	}
	
	.white {
		padding: 40px 15px 15px;
		/*position: relative;*/
	}
	
	.news {
		float: right;
		margin-right: 170px;
		height: 60px;
	}
	
	.news i {
		line-height: 60px;
		color: rgba(255, 255, 255, .7);
		font-size: 24px;
		cursor: pointer;
	}
	
	.news i:hover {
		color: #FFFFFF;
	}
	
	#qrCode {
		width: 120px;
		position: fixed;
		bottom: 80px;
		right: 0;
		background: #FFFFFF;
		border-radius: 5px;
		padding: 5px;
		z-index: 997;
		text-align: center;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
		cursor: pointer;
	}
	
	#qrCode #QQ {
		width: 120px;
		height: 40px;
		color: #FFFFFF;
		background: #4876FF;
		border-radius: 5px;
		margin-bottom: 10px;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	#qrCode #QQ a {
		display: flex;
		align-items: center;
		height: 40px;
		line-height: 40px;
		color: #FFFFFF;
	}
	
	#qrCode #QQ a i {
		font-size: 30px;
		margin-right: 10px;
	}
	
	#qrCode img {
		width: 120px;
		height: 120px;
	}
	
	#qrCode .close {
		position: absolute;
		bottom: -30px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 24px;
	}
</style>


// WEBPACK FOOTER //
// src/components/index.vue